// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__10gGO","info":"UpdateTermsInfo_info__106aN"};